import { Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { TablaSearchService } from './tabla-search.service';
import { GestionTercerosService } from '../../../dms/modulos/general/componentes/gestion-terceros/gestion-terceros.service';

@Component({
  selector: 'app-tabla-search',
  templateUrl: './tabla-search.component.html',
  styleUrls: ['./tabla-search.component.scss']
})
export class TablaSearchComponent implements OnInit {
 
  @Output() anadido = new EventEmitter<any>();
  
  constructor(
    public _gestionTercerosService: GestionTercerosService,
     public _tablaSearchService: TablaSearchService,
    ) { }
  ngOnInit() {
    this._tablaSearchService.filaAnadida = false;
    const b = {
      customerCode: '',
      customerName: ''
    };
    this._tablaSearchService.searchBoxResults(b);

  }

  clickElement(codeArcade: any) {
    this._tablaSearchService.filaAnadida = true;
    this._tablaSearchService.setCodeArcade(codeArcade);

    this.anadido.emit(codeArcade);

    // this._gestionTercerosService.customerForm.controls.datosIdentificacion.get('arcadCode').setValue(codeArcade.dataItem.LinkedCode);

  }


}
